import React from 'react';
import { Beep, state } from 'react-beep';
import logo from 'assets/images/logoFa.svg';
import { withRouter } from 'react-router-dom';
import Routes from 'configs/routes';
import { Link } from 'react-router-dom';

import styles from './styles';
import userRoles from 'utils/userRoles';
import { get } from 'lodash';

class AppBar extends Beep(['user']) {
  state = {
    isShowMenu: false,
    clicked: [],
  };

  handleShowMenu = () => {
    this.setState((prevState) => {
      return { isShowMenu: !prevState.isShowMenu };
    });
  };

  handelSubMenu(index, e) {
    const { isShowMenu } = this.state;
    if (isShowMenu === true) {
      let clicked = this.state.clicked;
      clicked[index] = !clicked[index];
      this.setState({ clicked: clicked });
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    this.setState({
      isShowMenu: false,
    });
  }

  handelRoute = () => {
    const { match } = this.props;
    state.path = match.path;
  };

  render() {
    const user = get(state, 'profile.user_profile');
    const { classes } = this.props;
    const route = Routes.find(
      (route) =>
        route.path === this.props.location.pathname ||
        route.path === '/company/:id' ||
        route.path === '/company/:id/report'
    );
    const { isShowMenu } = this.state;
    return (
      route &&
      route.appBar && (
        <header className="header">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-4 col-4 col-lg-6 col-xl-2 order-lg-2 order-xl-1 order-2">
                <div className="logo">
                  {this.props.location.pathname !== '/landing/naft' ? (
                    <Link to={'/'}>
                      {userRoles('hidden logo') ? (
                        <div className={classes.loginUser}>
                          <i className="icon-home" />
                          <span className="login-text">خانه</span>
                        </div>
                      ) : (
                        <img src={logo} alt="" />
                      )}
                    </Link>
                  ) : null}
                </div>
              </div>
              <div className="col-2 d-block d-sm-none order-lg-1 order-xl-1 order-1 ">
                <div className="user justify-content-between">
                  <div className="menu d-sm-block d-md-block d-xl-none ">
                    <div
                      className={[
                        classes.header_nav_hemberger,
                        isShowMenu && classes.open,
                      ].join(' ')}
                      onClick={this.handleShowMenu}
                    >
                      <span />
                      <span />
                      <span />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={[
                  classes.appBarMenu,
                  'col-md-12 col-12 col-lg-7 order-lg-3 mobileMenu',
                  isShowMenu && classes.header__menu__show,
                ].join(' ')}
              >
                <div
                  className={`nav ${
                    this.props.location.pathname === '/landing/naft' ||
                    userRoles('hidden logo')
                      ? 'hidden-logo'
                      : ''
                  }`}
                >
                  <ul>
                    <li
                      className={[
                        classes.openSubmenuItem,
                        this.state.clicked[1],
                      ].join(' ')}
                      onClick={this.handelSubMenu.bind(this, 1)}
                    >
                      <Link to={'/'}> بیمه وسایل نقلیه </Link>
                      <ul
                        className={[
                          classes.headerNavShow,
                          this.state.clicked[1],
                        ].join(' ')}
                      >
                        <li>
                          <a href="/l/third-party-insurance">بیمه شخص ثالث</a>
                        </li>
                        <li>
                          <a href="/l/body-insurance">بیمه بدنه</a>
                        </li>
                        <li>
                          <a href="/l/motor-insurance">بیمه موتور</a>
                        </li>
                      </ul>
                    </li>
                    {/* <li
                      className={[
                        classes.openSubmenuItem,
                        this.state.clicked[2],
                      ].join(' ')}
                      onClick={this.handelSubMenu.bind(this, 2)}
                    >
                      <Link to={'/'}> بیمه اشخاص </Link>
                      <ul
                        className={[
                          classes.headerNavShow,
                          this.state.clicked[2],
                        ].join(' ')}
                      >
                        <li>
                          <Link to={'/insurance/travel-insurance'}>
                            بیمه مسافرتی
                          </Link>
                        </li>
                        <li>
                          <Link to={'/insurance/therapeutic-insurance'}>
                            درمان تکمیلی
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                    {/* <li
                      className={[
                        classes.openSubmenuItem,
                        this.state.clicked[3],
                      ].join(' ')}
                      onClick={this.handelSubMenu.bind(this, 3)}
                    >
                      <Link to={'/'}> بیمه اموال </Link>
                      <ul
                        className={[
                          classes.headerNavShow,
                          this.state.clicked[3],
                        ].join(' ')}
                      >
                        <li>
                          <Link to={'/insurance/fire-insurance'}>
                            بیمه اتش سوزی
                          </Link>
                        </li>
                        <li>
                          <Link to={'/insurance/earthquake-insurance'}>
                            بیمه زلزله
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                  </ul>
                </div>
              </div>
              <div className="col-md-2 col-lg-1 col-xl-1 col-4 noSpace order-lg-4 order-4">
                <div className="salesOnline">
                  <a href="tel:21-91005110" className="support">
                    <i className="icon-headphones" />
                    <span className="ltr"> 021 - 91005110 </span>
                  </a>
                </div>
              </div>
              <div className="col-md-4 col-lg-2 col-xl-2 order-lg-5 col-2 col-sm-4 order-3">
                {this.props.location.pathname !== '/landing/naft' ? (
                  <Link
                    to={
                      state.token === null ? '/login' : '/profile/editProfile'
                    }
                  >
                    <div className={classes.loginUser}>
                      <i className="icon-user" />
                      {state.token === null ? (
                        <span className="login-text"> ورود / ثبت نام </span>
                      ) : (
                        <span className="login-text">
                          {user.lname
                            ? `${user.name ? user.name : ''} ${user.lname}`
                            : user.mobile}
                        </span>
                      )}
                    </div>
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
        </header>
      )
    );
  }
}

export default styles(withRouter(AppBar));
